import * as angular from "angular";
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {AgentModel} from "../../angular/models/agent.model";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentPackagesPrintPageCtrl implements IController {

  agent: AgentModel;
  tasks: any;

  private currentDate: any;
  private logoUrl: any;
  private totalPackages: any;

  constructor(private splitService: SplitService, private $window: IWindowService,
              private $timeout: ITimeoutService, private moment) {
  }

  $onInit() {
    this.currentDate = this.moment().valueOf();
    this.logoUrl = this.splitService.getSiteLogoUrl();
    this.totalPackages = _.sumBy(this.tasks,(t) => {
      return _.get(t, 'packageList[0].items.length', 0);
    });
  }

  $postLink() {
    this.$timeout(1000).then(() => {
      this.$window.print();
      this.$window.close();
    })
  };


}

angular
  .module('bringoz.admin.agents')
  .component('agentPackagesPrintPage', {
    bindings: {
      agent: '<',
      tasks: '<'
    },
    template: require('./agent-packages-print-page.html').default,
    controller: AgentPackagesPrintPageCtrl
  });
